import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getQuestionsAsDataTable,
  getQuestionsByQuizId,
  createNewQuestion,
  editQuestion,
  deleteQuestion,
  changeQuestionPublishState,
  orderQuestions,
} from './thunks';
import { QuestionsState } from './types';

export const name = 'questions';

const initialState: QuestionsState = {
  dataTable: {
    data: null,
    status: 'idle',
  },
  lookups: { data: [], status: 'idle' },
  create: {
    status: 'idle',
  },
  update: {
    status: 'idle',
  },
  delete: {
    status: 'idle',
  },
  changePublishState: {
    status: 'idle',
  },
  order: {
    status: 'idle',
  },
};

export const getQuestionsAsDataTableAsync = createAsyncThunk(
  name + '/getQuestionsAsDataTable',
  getQuestionsAsDataTable
);

export const getQuestionsByQuizIdAsync = createAsyncThunk(
  name + '/getQuestionsByQuizId',
  getQuestionsByQuizId
);

export const createNewQuestionAsync = createAsyncThunk(
  name + '/createNewQuestion',
  createNewQuestion
);

export const editQuestionAsync = createAsyncThunk(
  name + '/editQuestion',
  editQuestion
);

export const deleteQuestionAsync = createAsyncThunk(
  name + '/deleteQuestion',
  deleteQuestion
);

export const changeQuestionPublishStateAsync = createAsyncThunk(
  name + '/changeQuestionPublishState',
  changeQuestionPublishState
);

export const orderQuestionsAsync = createAsyncThunk(
  name + '/orderQuestions',
  orderQuestions
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDataTableData: (state) => {
      state.dataTable.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQuestionsAsDataTableAsync.pending, (state) => {
        state.dataTable.status = 'loading';
      })
      .addCase(getQuestionsAsDataTableAsync.fulfilled, (state, action) => {
        state.dataTable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getQuestionsAsDataTableAsync.rejected, (state) => {
        state.dataTable.status = 'failed';
      })
      .addCase(getQuestionsByQuizIdAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getQuestionsByQuizIdAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getQuestionsByQuizIdAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      })
      .addCase(createNewQuestionAsync.pending, (state) => {
        state.create.status = 'loading';
      })
      .addCase(createNewQuestionAsync.fulfilled, (state) => {
        state.create.status = 'idle';
      })
      .addCase(createNewQuestionAsync.rejected, (state) => {
        state.create.status = 'failed';
      })
      .addCase(editQuestionAsync.pending, (state) => {
        state.update.status = 'loading';
      })
      .addCase(editQuestionAsync.fulfilled, (state) => {
        state.update.status = 'idle';
      })
      .addCase(editQuestionAsync.rejected, (state) => {
        state.update.status = 'failed';
      })
      .addCase(deleteQuestionAsync.pending, (state) => {
        state.delete.status = 'loading';
      })
      .addCase(deleteQuestionAsync.fulfilled, (state) => {
        state.delete.status = 'idle';
      })
      .addCase(deleteQuestionAsync.rejected, (state) => {
        state.delete.status = 'failed';
      })
      .addCase(changeQuestionPublishStateAsync.pending, (state) => {
        state.changePublishState.status = 'loading';
      })
      .addCase(changeQuestionPublishStateAsync.fulfilled, (state) => {
        state.changePublishState.status = 'idle';
      })
      .addCase(changeQuestionPublishStateAsync.rejected, (state) => {
        state.changePublishState.status = 'failed';
      })
      .addCase(orderQuestionsAsync.pending, (state) => {
        state.order.status = 'loading';
      })
      .addCase(orderQuestionsAsync.fulfilled, (state) => {
        state.order.status = 'idle';
      })
      .addCase(orderQuestionsAsync.rejected, (state) => {
        state.order.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
